<template>
  <div class="container mt40">
    <div class="common-detail-content">
      <!-- 上半部 -->
      <div class="content-box">
        <div class="banner-box">
          <div class="left">
            <div class="banner">
              <el-carousel ref="carousel" :interval="5000" arrow="always" height="356px" :initial-index="bannerIdx">
                <el-carousel-item v-for="(item,index) in banners" :key="index">
                  <img :style="{width: '100%', height: '100%'}" :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="banner-label">
              <div :class="['banner-label-item', bannerActiveIdx == 0 ? 'active' : '']" @click="bannerChange(0)">全部图片({{info.bannerTotalNum || 0}})</div>
              <template v-if="info.bannerList.length > 0">
                <div :class="['banner-label-item', bannerActiveIdx === index + 1 ? 'active' : '']" v-for="(item, index) in info.bannerList" :key="index" @click="bannerChange(index + 1)">{{item.title}}({{item.imgList.length}})</div>
              </template>
            </div>
          </div>

          <div class="right">
            <div class="title">
              <div class="title-name">{{info.name}}</div>
              <div class="title-label">{{info.hotelLevel}}</div>
            </div>
            <div class="score">
              <div class="score-start">
                <div class="star-box" v-for="(star, starIdx) in 5" :key="starIdx">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= star ? '0':(17 * (info.avgReviewScore - star) + 'px')}" class="star-icon2"></div>
                </div>
              </div>
              <div class="score-grade">{{info.avgReviewScore == null ? '暂无评' : info.avgReviewScore}}分</div>
              <div class="score-number">{{info.reviewTimes || 0}}</div>
              <div class="score-text">人评论</div>
            </div>
            <div class="contactway">
              <div class="contactway-item">
                <div class="label">酒店地址:</div>
                <div class="text">
                  {{info.addressDetails}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">营业时间:</div>
                <div class="text">
                  {{info.openingTime}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">联系方式:</div>
                <div class="text">
                  {{info.phone ? info.phone : '暂无联系方式'}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">酒店简介:</div>
                <div class="text">
                  <p :class="{'show-all': showAll===true}">{{info.synopsis}}</p>
                  <span class="btn" @click="handleShow">{{showAll?'点击收起':'查看全部'}}</span>
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">人均消费:</div>
                <div class="price">
                  ￥{{info.consumptionPerPerson || 0}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flat-pattern">
          <div class="left-arrows" :class="{disabled: banners.length <= 6 || moveLeft === 0}" @click="handleBannerPrev"></div>
          <div class="img-list">
            <div class="img-box" :style="{left: -moveLeft + 'px'}">
              <div class="img-item" v-for="(item,index) in banners" :key="index">
                <img :src="item" alt="" @click="bannerIdxSel(index)">
              </div>
            </div>
          </div>
          <div class="right-arrows" :class="{disabled: banners.length <= 6 || moveLeft === (banners.length - 6) * imgHeight}" @click="handleBannerNext"></div>
        </div>
      </div>

      <!-- 中间 -->
      <div class="content-box">
        <div class="body-nav">
          <navTab :navList="navList" :tabPage="tabPage" :showDivider="true" @handleTabPage="handleTabPage"/>

          <div v-if="tabPage === 0" class="body-list">
            <template v-if="proList.length > 0">
              <div class="body-item" v-for="item in proList" :key="item.goodsId">
                <div class="left">
                  <div class="left-img"><img :src="item.mainPic" alt=""></div>
                  <div class="left-right">
                    <div class="right-title">{{item.name}}</div>
                    <div class="right-rule" @click="reservationNotesVisible = true">使用规则 ></div>
                    <el-dialog
                      title=""
                      :visible.sync="reservationNotesVisible"
                      width="40%"
                      :show-close="true">
                        <div class="rules" v-if="item.ruleInfoOptionList && item.ruleInfoOptionList.length > 0">
                          <template v-for="(stem,sidx) in item.ruleInfoOptionList">
                            <span v-if="stem.optionValue && stem.ruleCode !== 'PROMPT_INFO'" :key="sidx">{{stem.optionValue}}</span>
                          </template>
                        </div>
                    </el-dialog>
                    <div class="right-label">
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/icon3.png" alt="">
                        <span>{{item.usableArea}}m²</span>
                      </div>
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/icon4.png" alt="">
                        <span>{{item.onFloors}}层</span>
                      </div>
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/icon1.webp" alt="">
                        <span>{{item.windowsState}}</span>
                      </div>
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/icon2.webp" alt="">
                        <span>{{item.breakfastState}}</span>
                      </div>
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/bed.webp" alt="">
                        <span>{{item.bedShapeInformationStr}}</span>
                      </div>
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/icon6.png" alt="">
                        <span>{{item.maximumCapacity}}名成人</span>
                      </div>
                      <div class="label-item">
                        <img src="../../assets/images/hotelManage/icon5.png" alt="">
                        <span>{{item.addBedState}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="rigth-box">
                    <span class="sale-price"><span class="font-sm">¥</span>{{item.salePrice || 0}}</span>
                    <span class="goods-price" v-if="item.goodsPrice != null"><span class="font-sm">¥</span>{{item.goodsPrice || 0}}</span>
                  </div>
                  <div class="right-btn pointer" @click="handleToBook(item.id)">立即预订</div>
                </div>
              </div>
            </template>
            <div v-else class="no-data">暂无数据</div>
          </div>

          <div v-if="tabPage === 1" class="body-list">
            <div class="title">酒店介绍</div>
            <div class="text richContent" v-html="getRichContent(info.introduce)"></div>
          </div>
        </div>
      </div>

      <!-- 酒店信息 -->
      <div class="content-box">
        <div class="information">
          <div class="titile">酒店信息</div>
          <div class="label-box">
            <div>酒店服务</div>
            <div class="text richContent" v-html="getRichContent(info.hotelServices)"></div>
          </div>

          <el-divider class="divider"></el-divider>

          <div class="label-box">
            <div>酒店设施</div>
            <div class="text richContent" v-html="getRichContent(info.hotelFacilities)"></div>
          </div>

          <el-divider class="divider"></el-divider>

          <div class="label-box">
            <div>酒店政策</div>
            <div class="text richContent" v-html="getRichContent(info.reservationNotes)"></div>
          </div>

        </div>
      </div>

      <!-- 点评 -->
      <div class="content-box remark">
        <div class="information">
          <div class="titile">网友点评({{totalCount}})</div>
          <div class="comment-box">
            <div class="comment-list" v-for="item in commentList" :key="item.id">
              <div class="flex floor">
                <img :src="item.avatarUrl"/>
                <div class="com-name">
                  <div class="name">{{item.crtName}}</div>
                  <el-rate v-model="item.score" disabled show-score text-color="#FF0000" :score-template="item.score+'分'"/>
                </div>
                <div class="com-date">{{item.crtTime}}</div>
              </div>
              <div class="com-content">
                {{item.content}}
                <div class="img-comm">
                    <img v-for="(imgs,index) in item.pictures" :key="index" :src="imgs.url"/>
                </div>
                <div class="reply" v-if="item.replyContent">
                  <span class="lare">商家回复:</span>
                  {{item.replyContent}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination-self">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            :total="totalCount"
            @current-change="handleCurrentChangeCommen"
            :page-size="10"
            >
          </el-pagination>
        </div>
      </div>

    </div>
    <!-- 预订须知 -->
  </div>
</template>

<script>
import NavTab from '@/components/navTab'
import { loadInfo, saleList, loadCommentList, loadBedType } from '@/api/hotel/hoteDetail'
import { richTextWrap } from '@/common/js/utils'
import { queryDetailMixin } from '@/mixins/queryDetailMixin'
import { config } from '@/constant/config'
export default {
  mixins: [queryDetailMixin],
  data () {
    return {
      moduleType: 'HOTEL',
      grade: 3.5,
      navList: ['房产预定', '酒店介绍'],
      reservationNotesVisible: false,
      commentList: [],
      showAll: false,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      limit: 10,
      bedTypeList: []
    }
  },
  components: {
    'navTab': NavTab
  },
  eated () {
    this.loadCommentList()
  },
  methods: {
    // 富文本处理
    getRichContent (content) {
      if (content && typeof (content) === 'string') {
        const regexPre = new RegExp('pre>', 'g')
        content = content.replace(regexPre, 'div>')
      }
      return content
    },
    // 加载床型列表
    loadBedType () {
      loadBedType().then(res => {
        if (res.code === 0) {
          this.bedTypeList = res.data
        }
      })
    },
    // 床型处理
    bedShapeInformationDeal (data) {
      data = JSON.parse(data)
      let bedShapeInformation = ''
      data.forEach(val => {
        const obj = this.bedTypeList.find(v => v.code === val.bedType)
        bedShapeInformation = `${bedShapeInformation},${obj.value}`
      })
      bedShapeInformation = bedShapeInformation.substring(1)
      return bedShapeInformation
    },
    handleToBook (roomId) {
      const hotelInfo = {
        hotelName: this.info.name,
        hotelLevel: this.info.hotelLevel,
        addressDetails: this.info.addressDetails
      }
      this.$router.push({ path: 'hotelBook', query: { roomId, hotelInfo: JSON.stringify(hotelInfo) } })
    },
    loadInfo () {
      loadInfo(this.id).then(res => {
        if (res.code === 0) {
          const obj = res.data
          // 酒店类型处理
          switch (obj.level) {
            case '1':
            case '2':
              obj.hotelLevel = '经济型'
              break
            case '3':
              obj.hotelLevel = '舒适型'
              break
            case '4':
              obj.hotelLevel = '高档型'
              break
            case '5':
              obj.hotelLevel = '豪华型'
          }
          obj.reservationNotes = richTextWrap(obj.reservationNotes) || '暂无'
          this.loadIndustryOrMerchData(obj)
        }
      })
    },
    loadProducts () {
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        merchIndustryId: this.id
      }
      saleList(data).then(res => {
        this.loadList(res.data || [])
      })
    },
    handleCurrentChangeCommen (val) {
      this.page = val
      this.loadCommentList()
    },
    handleShow () {
      this.showAll = !this.showAll
    },
    loadCommentList () {
      const data = {
        limit: this.limit,
        page: this.page,
        merchIndustryId: this.id
      }
      loadCommentList(data).then(res => {
        if (res.code === 0) {
          this.commentList = res.data.list
          this.commentList.forEach(listItem => {
            const pictures = listItem.pictures ? JSON.parse(listItem.pictures) : []
            pictures.forEach(item => {
              if (item.index !== 1) {
                item.imgList = item.url.split(',')
                listItem.bannerList = item.imgList
              }
            })
          })
          this.totalPage = res.data.totalPage
          this.totalCount = res.data.totalCount
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.top {
  height: 166px;
  width: 100%;
}

.container {
  width: 1279px;
  overflow-x: auto;
}
.common-detail-content {
  .content-box {
    .body-list {
      .left {
        .left-right {
          .rules {
            span {
              display: inline-block;
              padding: 0 10px;
              height: 18px;
              margin-right: 12px;
              line-height: 18px;
              border: 1px solid #F0BD5D;
              border-radius: 2px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #F0BD5D;
              &:nth-of-type(2) {
                border-color: #C9ADAD;
                color: #C9ADAD;
              }
              &:nth-of-type(3) {
                color: #ADAFC9;
                border-color: #ADAFC9;
              }
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
